import React from "react";
import axios from "axios";

class HomepageNews extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            messages: []
        };
    }

    componentDidMount() {
        axios.get('/api/homepage-news/')
            .then((response) => {
                const messages = [];
                for (let index = 1; index <= 6; index++) {
                    const text = response.data[`text${index}`];
                    const hasLetters = typeof text === "string"
                        && Array.from(text).some((character) => character.toLowerCase() !== character.toUpperCase());
                    if (!hasLetters) {
                        continue;
                    }
                    messages.push({
                        text,
                        bold: response.data[`text${index}_b`]
                    });
                }
                this.setState({loaded: true, messages});
            })
            .catch(() => {
                this.setState({loaded: true, error: true});
            });
    }

    render() {
        const {className = "", style} = this.props;
        if (!this.state.loaded) {
            return <p>nieuws laden...</p>;
        }
        if (this.state.error) {
            return <p role="alert">Nieuws kon niet worden geladen.</p>;
        }
        if (this.state.messages.length === 0) {
            return null;
        }

        return (
            <div className={`announcement border ${className}`.trim()} style={style}>
                <div className="col-sm-12">
                    {this.state.messages.map((message, index) => (
                        <React.Fragment key={index}>
                            {message.bold
                                ? <strong>{message.text}</strong>
                                : <span>{message.text}</span>}
                            <br/>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    }
}

export default HomepageNews;
